export const firebaseConfigEnvs = {
  devEnv: {
    apiKey: "AIzaSyARL4tubKA57OtFBb2yK3u-j5be5_ai_y8",
    authDomain: "u-control-stats-test.firebaseapp.com",
    databaseURL: "https://u-control-stats-test.firebaseio.com",
    projectId: "u-control-stats-test",
    storageBucket: "u-control-stats-test.appspot.com",
    messagingSenderId: "489718690505",
    appId: "1:489718690505:web:5625cb7646bda47a3bd318",
    measurementId: "G-5WP6W34L3K",
  },
  stagEnv: {
    apiKey: "AIzaSyARL4tubKA57OtFBb2yK3u-j5be5_ai_y8",
    authDomain: "u-control-stats-test.firebaseapp.com",
    databaseURL: "https://u-control-stats-test.firebaseio.com",
    projectId: "u-control-stats-test",
    storageBucket: "u-control-stats-test.appspot.com",
    messagingSenderId: "489718690505",
    appId: "1:489718690505:web:5625cb7646bda47a3bd318",
    measurementId: "G-5WP6W34L3K",
  },
  prodEnv: {
    apiKey: "AIzaSyApT7cK7o6kHBTvnHS-3a53tlX0lDWLwW4",
    authDomain: "u-control-de55b.firebaseapp.com",
    databaseURL: "https://u-control-de55b.firebaseio.com",
    projectId: "u-control-de55b",
    storageBucket: "u-control-de55b.appspot.com",
    messagingSenderId: "772937998391",
    appId: "1:772937998391:web:cc69ea57a2e51fdaeddfb2",
    measurementId: "G-5WP6W34L3K",
  },
};

export function firebaseConfig() {
  if (process.env.BUILD_ENV === "dev") {
    return firebaseConfigEnvs.devEnv;
  } else if (process.env.BUILD_ENV === "staging") {
    return firebaseConfigEnvs.stagEnv;
  } else if (process.env.BUILD_ENV === "prod") {
    return firebaseConfigEnvs.prodEnv;
  } else {
    return firebaseConfigEnvs.devEnv;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./firebase.config.ts